import Vue from 'vue'
import Router from 'vue-router'
const layout = () => import('@/layout/index')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('@/views/index')
        },
        {
          path: '/about',
          name: '关于我们',
          component: () => import('@/views/about/aboutUs')
        },
        {
          path: '/product',
          name: '产品及解决方案',
          component: () => import('@/views/product/product')
        },
        {
          path: '/talentRecruitment',
          name: '人才招聘',
          component: () => import('@/views/recruitment/talentRecruitment')
        },
        {
          path: '/contactUs',
          name: '联系我们',
          component: () => import('@/views/contact/contactUs')
        },
        {
          path: '/news',
          name: '新闻资讯',
          component: () => import('@/views/news/news')
        },
        {
          path: '/indexNews',
          name: '新闻详情',
          component: () => import('@/views/news/indexNewDetil')
        }
        // {
        //   path: '/news',
        //   name: '新闻资讯',
        //   component: () => import('@/views/news/news'),
        //   children: [
        //     {
        //       path: '',
        //       name: 'index',
        //       component: () => import('@/views/news/news')
        //     },
        //     {
        //       path: 'indexNews',
        //       name: 'indexNews',
        //       component: () => import('@/views/news/indexNewDetil')
        //     }
        //   ]
        // }

      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js